module.exports = __webpack_public_path__ + "img/welcome.31ff8457.png";